/**
 * ARIA specification version to use.
 *
 * @public
 * @since 11.10.0
 */
export type AriaVersion = "1.2" | "1.3" | "latest";

/**
 * @internal
 */
export const DEFAULT_ARIA_VERSION: AriaVersion = "1.2";
